import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { verifyUser } from "../api/authServices";

export default function ProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      await verifyUser();
      setIsAuth(true);
    } catch (error) {
      localStorage.removeItem("token");
      setIsAuth(false);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return isAuth ? children : <Navigate to="/signin" />;
}